var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box 1",
    clipPath: "url(#clip0_2107_4484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_12---Stacked-Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_83_",
    d: "M15.2681 7.21484H12.1914L10.8164 8.58984H13.227C13.3547 8.59068 13.4803 8.62148 13.5939 8.67977L15.2681 7.21484Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_11_",
    d: "M8.27539 13.5391H9.37568V14.0891H8.27539V13.5391Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_82_",
    d: "M14.0516 9.41525V14.4769L15.6191 12.9094C15.6719 12.8586 15.7017 12.7885 15.7016 12.7152V7.56641L13.9766 9.07588C14.0257 9.18229 14.0513 9.29803 14.0516 9.41525Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_81_",
    d: "M6.54329 15.1081L6.54825 15.1034C6.59806 15.052 6.62588 14.9833 6.62579 14.9117V9.41172C6.62579 9.25986 6.50268 9.13672 6.35079 9.13672H0.575786C0.423921 9.13672 0.300781 9.25983 0.300781 9.41172V14.9117C0.300781 15.0636 0.423891 15.1867 0.575786 15.1867H6.35079C6.42282 15.1869 6.492 15.1586 6.54329 15.1081ZM3.05079 14.0867C3.05079 14.3905 2.80454 14.6367 2.50079 14.6367H1.40077C1.09701 14.6367 0.85076 14.3905 0.85076 14.0867V13.5367C0.85076 13.2329 1.09701 12.9867 1.40077 12.9867H2.50076C2.80451 12.9867 3.05076 13.2329 3.05076 13.5367V14.0867H3.05079ZM5.80078 14.6367H4.97576C4.8239 14.6367 4.70076 14.5136 4.70076 14.3617C4.70076 14.2098 4.82387 14.0867 4.97576 14.0867H5.80078C5.95264 14.0867 6.07578 14.2098 6.07578 14.3617C6.07578 14.5136 5.95267 14.6367 5.80078 14.6367ZM5.80078 13.5367H4.97576C4.8239 13.5367 4.70076 13.4136 4.70076 13.2617C4.70076 13.1099 4.82387 12.9867 4.97576 12.9867H5.80078C5.95264 12.9867 6.07578 13.1098 6.07578 13.2617C6.07578 13.4136 5.95267 13.5367 5.80078 13.5367Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_10_",
    d: "M1.40039 13.5391H2.50068V14.0891H1.40039V13.5391Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_80_",
    d: "M13.4152 15.1095L13.4183 15.1042L13.4235 15.0993C13.4722 15.0489 13.4999 14.9818 13.5008 14.9117V9.41172C13.5008 9.25986 13.3777 9.13672 13.2258 9.13672H7.45079C7.29892 9.13672 7.17578 9.25983 7.17578 9.41172V14.9117C7.17578 15.0636 7.29889 15.1867 7.45079 15.1867H13.2258C13.2965 15.1863 13.3644 15.1586 13.4152 15.1095ZM9.92576 14.0867C9.92576 14.3905 9.67951 14.6367 9.37576 14.6367H8.27577C7.97201 14.6367 7.72576 14.3905 7.72576 14.0867V13.5367C7.72576 13.2329 7.97201 12.9867 8.27577 12.9867H9.37576C9.67951 12.9867 9.92576 13.2329 9.92576 13.5367V14.0867ZM12.6758 14.6367H11.8508C11.6989 14.6367 11.5758 14.5136 11.5758 14.3617C11.5758 14.2098 11.6989 14.0867 11.8508 14.0867H12.6758C12.8276 14.0867 12.9508 14.2098 12.9508 14.3617C12.9508 14.5136 12.8276 14.6367 12.6758 14.6367ZM12.6758 13.5367H11.8508C11.6989 13.5367 11.5758 13.4136 11.5758 13.2617C11.5758 13.1099 11.6989 12.9867 11.8508 12.9867H12.6758C12.8276 12.9867 12.9508 13.1098 12.9508 13.2617C12.9508 13.4136 12.8276 13.5367 12.6758 13.5367Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_79_",
    d: "M10.2918 2.07821L11.966 0.613281H9.74425L7.97656 1.98827H9.9249C10.0526 1.98911 10.1782 2.01994 10.2918 2.07821Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_78_",
    d: "M6.71172 0.692479C6.69984 0.704661 6.68688 0.715699 6.67295 0.725475L4.875 1.98827H7.08325L8.85094 0.613283H6.90257C6.83092 0.613012 6.76213 0.641557 6.71172 0.692479Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_77_",
    d: "M12.3183 6.30615C12.3707 6.25574 12.4005 6.18632 12.4009 6.11365V0.964844L10.6758 2.47431C10.7249 2.5807 10.7505 2.69647 10.7509 2.81366V7.87614L12.3183 6.30615Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_76_",
    d: "M3.13555 7.29404C3.12367 7.30622 3.11071 7.31726 3.09678 7.32704L1.29883 8.58984H3.37702C3.34445 8.50177 3.32733 8.40874 3.32643 8.31484V7.21485C3.25475 7.21457 3.18596 7.24309 3.13555 7.29404Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path_9_",
    d: "M4.97656 6.9375H6.07685V7.48749H4.97656V6.9375Z",
    fill: "#43419E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_75_",
    d: "M4.15 8.58906H9.925C9.99697 8.5893 10.0662 8.56115 10.1175 8.51068L10.123 8.50517C10.1726 8.45395 10.2002 8.38537 10.2 8.31405V2.81407C10.2 2.6622 10.0769 2.53906 9.925 2.53906H4.15C3.99814 2.53906 3.875 2.66217 3.875 2.81407V8.31405C3.875 8.46595 3.99814 8.58906 4.15 8.58906ZM8.55001 6.38906H9.37502C9.52688 6.38906 9.65002 6.51217 9.65002 6.66406C9.65002 6.81593 9.52691 6.93907 9.37502 6.93907H8.55001C8.39814 6.93907 8.275 6.81596 8.275 6.66406C8.275 6.5122 8.39811 6.38906 8.55001 6.38906ZM8.55001 7.48907H9.37502C9.52688 7.48907 9.65002 7.61218 9.65002 7.76408C9.65002 7.91597 9.52691 8.03908 9.37502 8.03908H8.55001C8.39814 8.03908 8.275 7.91597 8.275 7.76408C8.275 7.61218 8.39811 7.48907 8.55001 7.48907ZM4.42501 6.93907C4.42501 6.63531 4.67126 6.38906 4.97502 6.38906H6.075C6.37876 6.38906 6.62501 6.63531 6.62501 6.93907V7.48907C6.62501 7.79283 6.37876 8.03908 6.075 8.03908H4.97502C4.67126 8.03908 4.42501 7.79283 4.42501 7.48907V6.93907Z",
    fill: "#43419E"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_4484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4,
    height: 15.4,
    fill: "white",
    transform: "translate(0.300781 0.203125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRider);
export default __webpack_public_path__ + "static/media/rider.d71f2c0e.svg";
export { ForwardRef as ReactComponent };